export const APP_VERSION = '1.25.0';
